import { render, staticRenderFns } from "./message-status-icon.vue?vue&type=template&id=1f0d455e&scoped=true&"
import script from "./message-status-icon.vue?vue&type=script&lang=js&"
export * from "./message-status-icon.vue?vue&type=script&lang=js&"
import style0 from "./message-status-icon.vue?vue&type=style&index=0&id=1f0d455e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0d455e",
  null
  
)

export default component.exports